export const manualSiConstants = {
  MANY_MANUAL_SI_POST: 'MANY_MANUAL_SI_POST',
  MANY_MANUAL_SI_SUCCESS: 'MANY_MANUAL_SI_SUCCESS',
  MANY_MANUAL_SI_ERROR: 'MANY_MANUAL_SI_ERROR',
};
